import script from "./CoreUiChatClientAvatar.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoreUiChatClientAvatar.vue?vue&type=script&lang=ts&setup=true"

import "./CoreUiChatClientAvatar.vue?vue&type=style&index=0&id=669c26fd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-669c26fd"]])

export default __exports__